import { InspectionTypeOverrides } from 'types'

const rooftopOverride: InspectionTypeOverrides = (model) => {
  const hasBoundingBox = Boolean(
    (model as unknown as { data?: { boundingBox?: unknown } } | undefined)?.data
      ?.boundingBox
  )
  return {
    fallbackUnit: 'Feet',
    feature: {
      layerHotbar: true,
      changeTexture: true,
      plane2D: false,
      cameraPoses: false,
      drawInspectionAreas: true,
      toggleInspectionGridButton: hasBoundingBox,
      dataValidationControl: true,
      thermalGradientPanel: true,
      temperatureDisplay: true,
      inspectionGridSettings: true,
      infoModal: true,
      exportControls: false,
      unitTaggingControls: false,
      allowThicknessMeasurement: false,
      defectsReportWithScreenshots: false,
      labelVisible: true,
      areaVisible: true,
      compassVisible: true,
      labelCullingEnabled: false,
      temperatureProbeUsesCursorData: true,
    },
    annotationForm: {
      showDamageTypeSelector: true,
      showScreenshots: true,
      showNotes: true,
      showGeospatialLink: true,
    },
  }
}

export default rooftopOverride
